import { render } from "./CheckboxesComponent.vue?vue&type=template&id=bdceb3e2"
import script from "./CheckboxesComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__